import notificationReducer from 'components/manufacturer/shared/NotificationSlice';
import paymentReducer from 'components/manufacturer/Payments/store/paymentSlice';

import {combineReducers} from '@reduxjs/toolkit';

import {appApiReducerPath, appApiReducer} from 'store/dashboard/appApi';

const rootReducer = combineReducers({
    notification: notificationReducer,
    payment: paymentReducer,
    [appApiReducerPath]: appApiReducer,
});

export default rootReducer;
